export default __webpack_public_path__ + "static/media/18.def00b6d.jpg";